import { IconButton, Tooltip } from '@chakra-ui/react';
import { ReactComponent as DuplicateIcon } from 'assets/icons/duplicate.svg';
import { NODE_CREATED } from 'constants/mixpanel';
import { Mixpanel } from 'libs/third-party/Mixpanel/mixpanel';
import { duplicateActiveWidgets } from 'modules/Editor/Editor.helpers';
import { useTranslation } from 'react-i18next';

import { BUTTON_SIZE, ICON_SIZE } from '../WidgetControl.config';

export const DuplicateControl = () => {
  const { t } = useTranslation('editor_toolbar', { useSuspense: false });
  const label = t('duplicate');

  const onClick = () => {
    duplicateActiveWidgets();
    Mixpanel.track(NODE_CREATED.eventName, {
      from: NODE_CREATED.from.InContextMenu,
    });
  };

  return (
    <Tooltip hasArrow placement='bottom' label={label} bg='black'>
      <IconButton
        aria-label={label}
        color='font.500'
        width={`${BUTTON_SIZE}px`}
        height={`${BUTTON_SIZE}px`}
        icon={<DuplicateIcon width={ICON_SIZE} height={ICON_SIZE} />}
        variant='icon-btn-widget-ctrl'
        onClick={onClick}
      />
    </Tooltip>
  );
};
